import React from 'react';
import PropTypes from 'prop-types';
import {
  Panel,
  RefinementList,
  ToggleRefinement,
} from 'react-instantsearch-dom';

function PublicationFilterPanel({ publication }) {
  // defaultRefinement needs to be an array with only valid string values
  const defaultRefinement = [publication]
    .flat()
    .map((pub) => (typeof pub === 'string' ? pub : pub?.name))
    .filter(Boolean);

  return (
    <div className="card mb-3">
      <div className="card-body">
        <Panel header="Filter by publication">
          <ToggleRefinement
            attribute="publication.top_publication"
            label="Top publications only"
            value={true}
            defaultRefinement={false}
          />
          <Panel header="Publications" className="mt-1">
            <RefinementList
              attribute="publication.name"
              limit={6}
              showMore={true}
              showMoreLimit={15}
              searchable={true}
              defaultRefinement={defaultRefinement.length ? defaultRefinement : undefined}
            />
          </Panel>
        </Panel>
      </div>
    </div>
  );
}

PublicationFilterPanel.propTypes = {
  publication: PropTypes.string,
};

PublicationFilterPanel.defaultProps = {
  publication: '',
};

export default PublicationFilterPanel;
